import base from "../baseurl";
import token from "../getTk";

const Delete = async (id) => {
  const tokenA = token.get();
  const api = base.extend({
    hooks: {
      beforeRequest: [
        (request) => {
          request.headers.set("jwt", `${tokenA}`);
        },
      ],
    },
  });
  const Create = await api
    .post("good-delivery-events/delete", {
      json: {
        id,
      },
    })
    .json();
  console.log(Create);
  return Create;
};

export default Delete;
